/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BaseResponse } from '../../models/base-response';
import { MediaRecentListFullResponse } from '../../models/media-recent-list-full-response';

export interface MediaControllerRecentFilesAndFolders$Params {
  recentLimit?: number;
}

export function mediaControllerRecentFilesAndFolders(http: HttpClient, rootUrl: string, params?: MediaControllerRecentFilesAndFolders$Params, context?: HttpContext): Observable<StrictHttpResponse<BaseResponse & {
'data'?: MediaRecentListFullResponse;
}>> {
  const rb = new RequestBuilder(rootUrl, mediaControllerRecentFilesAndFolders.PATH, 'get');
  if (params) {
    rb.query('recentLimit', params.recentLimit, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<BaseResponse & {
      'data'?: MediaRecentListFullResponse;
      }>;
    })
  );
}

mediaControllerRecentFilesAndFolders.PATH = '/file-manager/recents';
